// extracted by mini-css-extract-plugin
export default {"geoMap":"VehicleMapWidget_geoMap__yNSpA"};